// Event, Dialog
import EventBus from "@/event/EventBus";

// Api
import api from '@/api/baseApi';

// Constant
import { SETTINGS_RENTAL_API } from "@/constant/apiSettings";
import { POPUP_ID } from "@/constant/baseConstant";
import { API_CALL_STATUS } from "@/constant/baseConstant";

// Extend
import baseRentalService from '@/scripts/rentalService/baseRentalService';

export default {

    extends: baseRentalService,

    data() {

        return {
            dataNote: [
                {
                    label: this.$t('hardwareFixationModal.notesTitle'),
                    children: [
                        {
                            label: this.$t('hardwareFixationModal.note1'),
                        },
                        {
                            label: this.$t('hardwareFixationModal.note2'),
                        },
                    ]
                },
            ],
        };
    },

    props: {
        targetImage: {
            type: Object,
            default: null,
        },
    },

    methods: {

        // Close this pop-up
        closeThisPopup() {
            this.closePopup(POPUP_ID.HARDWARE_FIXATION);
        },

        //#region Hardware fixation
        confirm() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            setTimeout(() => {
                let data = {
                    machineId: this.targetImage.id,
                    hardwareFixation: !this.targetImage.hardwareFixation,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                api.baseRequest(SETTINGS_RENTAL_API.HARDWARE_FIXATION, data)
                    .then(() => {
                        EventBus.$emit("processingEventRental", { event: "isLoadingElement", data: [this.targetImage.id] });
                        EventBus.$emit("processingEventRental", { event: "autoRefresh" });
                        this.closeThisPopup();
                        this.notificationSuccess(
                            this.$t('hardwareFixationModal.successTitle'),
                            this.$t(data.hardwareFixation ? 'hardwareFixationModal.successMessageFixed' : 'hardwareFixationModal.successMessageRemoved', { id: this.targetImage.id, name: this.targetImage.name })
                        );
                        this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                    })
                    .catch(error => {
                        this.processCatchApiRequest(error, this.$t('hardwareFixationModal.failedMessage'))
                    });
            }, this.smoothTimeOut);
        },
        //#endregion 
    },
}